import { useOrgUser, useOrganizations } from '@cibo/profile'
import { useProgram } from '@cibo/programs'
import { useParamAsInteger } from '@cibo/ui'
import { Breadcrumbs, Link } from '@mui/material'
import { LayoutSection } from 'components/ImpactLayout'
import { ADMIN_ROUTES, AdminProgramRouteParams } from 'navigation/types'
import { useTranslation } from 'react-i18next'
import { Outlet, Link as RRLink, generatePath, useParams } from 'react-router-dom'

export const AdminProgramDetailLayout = () => {
  const { t } = useTranslation('impact/pages/Amdin/ProgramDetail')
  const { organizationId, programId } = useParams<AdminProgramRouteParams>()
  const userId = useParamAsInteger('userId')
  const program = useProgram({ programId })
  /**
   * @todo
   * why isn't there an org detail endpoint????
   */
  const allOrganizations = useOrganizations()
  const org = allOrganizations.data?.items.find(
    organization => organization.orgInfo.orgId === organizationId
  )
  const user = useOrgUser(userId)

  return (
    <LayoutSection>
      <Breadcrumbs>
        <Link component={RRLink} to={'../'} underline="hover" color="inherit">
          {t('programs')}
        </Link>
        {!!program.data?.content.fields.title && (
          <Link
            component={RRLink}
            to={generatePath(ADMIN_ROUTES.PROGRAM_DETAIL, { programId })}
            aria-current="page"
          >
            {program.data?.content.fields.title}
          </Link>
        )}
        {!!org && (
          <Link
            component={RRLink}
            to={generatePath(ADMIN_ROUTES.PROGRAM_ORGANIZATION_DETAIL, {
              programId,
              organizationId: org.orgInfo.orgId,
            })}
            aria-current="page"
          >
            {org.orgInfo.orgName}
          </Link>
        )}
        {!!user.data && !!org && (
          <Link
            component={RRLink}
            to={generatePath(ADMIN_ROUTES.PROGRAM_ORGANIZATION_DETAIL, {
              programId,
              organizationId: org.orgInfo.orgId,
              userId: user.data.userId?.toString(),
            })}
            aria-current="page"
          >
            {user.data.displayNameFull}
          </Link>
        )}
      </Breadcrumbs>
      <Outlet />
    </LayoutSection>
  )
}
